// src/components/OfferPopup.js
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchFestivalRequest } from "../store/slices/festivalSlice";
import "./OfferPopup.css";

const OfferPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [festival, setFestival] = useState(null);

  const location = useLocation();
  const dispatch = useDispatch();

  // ✅ SAFE SELECTOR (no undefined error)
  const { data = [] } = useSelector((state) => state.festival);

  // ✅ CALL API ONLY ON HOME PAGE
  useEffect(() => {
    if (location.pathname !== "/") {
      setIsOpen(false);
      return;
    }

    dispatch(fetchFestivalRequest());
  }, [location.pathname, dispatch]);

  // ✅ SAME LOGIC (UNCHANGED)
  useEffect(() => {
    if (!data?.length) return;

    const fest = data[0];

    // ✅ Check active status
    if (!fest.is_active || fest.status !== "active") return;

    // ✅ Check date condition
    const today = new Date();
    const startDate = new Date(fest.start_date);
    const endDate = new Date(fest.end_date);

    if (today >= startDate && today <= endDate) {
      const seen = sessionStorage.getItem("festivalSeen");

      if (!seen) {
        setFestival(fest);
        setTimeout(() => setIsOpen(true), 100);
      }
    }
  }, [data, location.pathname]);

  const handleClose = () => {
    sessionStorage.setItem("festivalSeen", "true");
    setIsOpen(false);
  };

  // ✅ ESC + AUTO CLOSE (same logic)
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        handleClose();
      }
    };

    const timer = setTimeout(() => {
      handleClose();
    }, 10000);

    window.addEventListener("keydown", handleEsc);

    return () => {
      clearTimeout(timer); // ✅ FIX (memory leak avoid)
      window.removeEventListener("keydown", handleEsc);
    };
  }, []);

  if (!isOpen || !festival) return null;

  return ReactDOM.createPortal(
    <div className="popup-overlay" onClick={handleClose}>
      <div className="popup-box" onClick={(e) => e.stopPropagation()}>
        {/* Close Button */}
        <button
          className="popup-close"
          onClick={handleClose}
          aria-label="Close"
        >
          &times;
        </button>

        <div className="popup-layout">
          {/* Left Side: Image */}
          <div className="popup-image-container">
            <img
              src={festival.image_url}
              alt={festival.title}
              className="popup-image"
            />
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default OfferPopup;
